import z from 'zod';

export const IpLocationSchema = z.object({
  ipVersion: z.number().nullable(),
  ipAddress: z.string().ip().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  countryName: z.string().nullable(),
  countryCode: z.string().length(2).nullable(),
  timeZone: z.string().optional(),
  zipCode: z.string().nullable(),
  cityName: z.string().nullable(),
  regionName: z.string().nullable(),
  continent: z.string().nullable(),
  continentCode: z.string().length(2).nullable(),
  isProxy: z.boolean(),
  currency: z
    .object({
      code: z.string().length(3),
      name: z.string(),
    })
    .optional(),
  language: z.string().optional(),
  tlds: z.array(z.string()).optional(),
});

export type IpLocation = z.infer<typeof IpLocationSchema>;
